import { render, staticRenderFns } from "./frame.vue?vue&type=template&id=bdbd4d4a&scoped=true&"
import script from "./frame.vue?vue&type=script&lang=js&"
export * from "./frame.vue?vue&type=script&lang=js&"
import style0 from "./frame.vue?vue&type=style&index=0&lang=css&"
import style1 from "./frame.vue?vue&type=style&index=1&id=bdbd4d4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbd4d4a",
  null
  
)

export default component.exports